<template>
  <DateQuestion
    ref="child"
    v-on:answerUpdated="onAnswerUpdated"
    :question="question"
    :answer="answer"
    :isDisabled="isDisabled"
    :disableFutureDates="true"
  ></DateQuestion>
</template>

<script>
  import DateQuestion from './DateQuestion'

  export default {
    props: ['question', 'answer', 'isDisabled'],
    name: 'DateLteTodayQuestion',
    components: { DateQuestion },
    methods: {
      isValid () {
        return this.$refs.child.isValid()
      },
      onAnswerUpdated (answer) {
        this.$emit('answerUpdated', answer)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DateLteTodayQuestion.vue?5e4ff4c3